import React from "react";
import { FormInputSelect } from "components/form";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useFormContext } from "react-hook-form";
import { FinanceProgramFormValues } from "../../../types";
import { setProgramDeps } from "../../../lib";
import { deskingSelectors } from "../../../model";

export const FinanceFieldSelector = () => {
  const { control, setValue } = useFormContext<FinanceProgramFormValues>();

  const dispatch = useDispatch();

  const financePrograms = useSelector(deskingSelectors.financePrograms);
  const financeProgramSelectOptions = useSelector(deskingSelectors.financeProgramSelectOptions);

  const handleSelectProgram = (programId: string) => {
    setValue("financeQuote.program", programId);

    setProgramDeps({
      dispatch,
      setValue,
      programConfig: financePrograms?.[programId]?.paymentOptionsConfiguration ?? null,
    });
  };

  return (
    <Controller
      control={control}
      name="financeQuote.program"
      render={({ field }) => (
        <FormInputSelect
          variant="standard"
          label="Select Program"
          options={financeProgramSelectOptions?.reverse() ?? []}
          disabled={!financeProgramSelectOptions?.length}
          {...field}
          onChange={handleSelectProgram}
        />
      )}
    />
  );
};
